import React from 'react';
import LoadingSkeleton from 'app/components/match/bestPlayer/LoadingSkeleton';
import VotingLeaderPlaceholder from 'app/components/match/bestPlayer/VotingLeaderPlaceholder';
import { ProfileRowDataContainer } from 'app/components/profile/ProfileStyles';
import { Container, DeactivateableTypography, ImageContainer } from 'app/components/match/bestPlayer/VotingLeaderStyles';
import { COLORS, Image, ImageEntity } from '@fupa/fupa-uikit';
import ProfileImageFallbackIcon from 'app/styles/ProfileImageFallbackIcon';
import VotingStatus from 'app/components/match/bestPlayer/VotingStatus';
const VotingLeader = _ref => {
  let {
    isFetching,
    leader,
    onClick,
    homeTeamSlug,
    votingStatus
  } = _ref;
  if (isFetching) {
    return /*#__PURE__*/React.createElement(LoadingSkeleton, null);
  }
  if (votingStatus === VotingStatus.NotStarted) {
    return /*#__PURE__*/React.createElement(VotingLeaderPlaceholder, {
      text: "Die Abstimmung f\xFCr den besten Spieler ist noch nicht freigegeben."
    });
  }
  if (!leader || !leader.player) {
    return /*#__PURE__*/React.createElement(VotingLeaderPlaceholder, {
      text: "Es wurde noch keine Stimme abgegeben."
    });
  }
  const player = leader.player;
  const team = leader.team;
  const image = player.image ? /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Player,
    circle: true,
    src: player.image,
    ratio: "1:1",
    width: 64,
    height: 64
  }) : /*#__PURE__*/React.createElement(ProfileImageFallbackIcon, null);
  const text = leader.count === 1 ? "".concat(leader.count, " Stimme") : "".concat(leader.count, " Stimmen");
  return /*#__PURE__*/React.createElement(Container, {
    onClick: onClick,
    "data-sentry-element": "Container",
    "data-sentry-component": "VotingLeader",
    "data-sentry-source-file": "VotingLeader.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    color: homeTeamSlug === (team === null || team === void 0 ? void 0 : team.slug) ? COLORS.fupaPrimary : COLORS.fupaSecondary,
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "VotingLeader.tsx"
  }, image), /*#__PURE__*/React.createElement(ProfileRowDataContainer, {
    "data-sentry-element": "ProfileRowDataContainer",
    "data-sentry-source-file": "VotingLeader.tsx"
  }, /*#__PURE__*/React.createElement(DeactivateableTypography, {
    deactivated: player.isDeactivated,
    variant: "subheading",
    "data-sentry-element": "DeactivateableTypography",
    "data-sentry-source-file": "VotingLeader.tsx"
  }, "".concat(player.firstName, " ").concat(player.lastName)), /*#__PURE__*/React.createElement(DeactivateableTypography, {
    deactivated: player.isDeactivated,
    variant: "body2",
    "data-sentry-element": "DeactivateableTypography",
    "data-sentry-source-file": "VotingLeader.tsx"
  }, text)));
};
export default VotingLeader;